import React from 'react';
import iconSun from '../../images/icon-sun.svg';
import iconMoon from '../../images/icon-moon.svg';
import "./header.css";

function Header({modes, setModes, ren, tab }){
    
    function swithes(){
        const lightModes = 'lights';

        const bannerImageDark = 'banner-dark';
        const bannerImageLite = 'banner-light';
        modes ? document.body.classList.add(lightModes) : document.body.classList.remove(lightModes);
        modes ? document.querySelector("#banner").classList.replace(bannerImageDark, bannerImageLite) : document.querySelector("#banner").classList.replace(bannerImageLite, bannerImageDark);
        document.querySelector(".inp_con_dark").classList.toggle("inp_lite");
        setModes(!modes);
        ren(tab);
    }
    return(
        <div className="heading">
            <h1>Todo</h1>
            <span className="switch" onClick={swithes}>
                <img src={ modes ? iconSun : iconMoon} alt="moon/sun" />
            </span>
        </div>
    )
}
export default Header;